@if (text()) {
  <div class="my-6 flex w-full items-center gap-4">
    <div class="h-px flex-grow bg-linear-to-r from-transparent to-primary/95"></div>
    <span class="flex-shrink-0 text-sm font-medium text-primary/95">{{ text() }}</span>
    <div class="h-px flex-grow bg-linear-to-r from-primary/95 to-transparent"></div>
  </div>
} @else {
  <div class="h-px my-6 w-full bg-linear-to-r from-transparent via-primary/95 to-transparent"></div>
}
